import { ScriptProps } from "next/script";
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../../store/AuthSlice";
import accessToken from "../../utils/access-token"
import SellerNavbar from "./SellerNavbar";
import LoginRegister from "../LoginRegister";
import Confirmation from "../General/Confirmation";
import { useRouter } from "next/router";
import { getCountryList, setHeroSectionVisible } from "../../store/CoreSlice";
import { setSnackBar } from "../../store/ToastSlice";
import { setFileData } from "../../store/CoreSlice";

const Seller = ({ background, children } : any) => {	
	const router = useRouter();
	const dispatch : any = useDispatch()

	useEffect(() => {
		const token = accessToken.getAccessToken();
		if(token !== undefined && token !== '' && token) {
			const payload = {
				isLoggedIn : true,
				name : accessToken.getCredentials().user
			}
			dispatch(setUserDetails(payload));
		}

		/**
		 	Since a common state is being managed for the file storing across the platform, 
			clearing of this variable is mandatory at a page change. Else the files will be 
			shown in any other form.
		 */
		router.events.on('routeChangeStart', () => {
			dispatch(setFileData({
				data : [],
				action : 'replace'
			}));
		})

		/* :: Checking if the app is online or offline :: */
		window.addEventListener('online', () => {
			dispatch(setSnackBar({
				message : 'You are back online!',
				color : 'success',
				timeOut : 10000
			}));
		})

		window.addEventListener('offline', () => {
			dispatch(setSnackBar({
				message : 'You are offline!',
				color : 'error',
				timeOut : -1
			}))
		});
	}, [])


	const intersectionOptions = useMemo(() => {
		return {
			root : null,
			rootMargin : '0px',
			threshold : 0
		}
	}, []);

	useEffect(() => {
		const heroSection = document.getElementById('hero-section');
		const observer = new IntersectionObserver(intersectionCallback, intersectionOptions);
		if(heroSection)
			observer.observe(heroSection);
		
		return () => {
			if(heroSection)
				observer.unobserve(heroSection);
		}
	}, [router.pathname])

	const intersectionCallback = (entries : any) => {
		entries.forEach((entry : any )=> {
			dispatch(setHeroSectionVisible(entry.isIntersecting));
		})
	}

	return <div style={{ background : background }}>
		<div className="relative">
			{/* <SellerNavbar /> */}
			{children}
			<LoginRegister themeClass = "theme-green" />
			<Confirmation />
		</div>
	</div>;
};

Seller.defaultProps = {
	background : '#EAEAEA'
}

Seller.SellerLayout = function(page : any) {
	return page
}

export default Seller;